module.exports = __webpack_public_path__ + "static/media/Candace.d0226e61.png";